<template>
  <div :class="classes">
    <Label v-if="props.label" :disabled="props.disabled" :for="name">
      {{ props.label }}
    </Label>
    <input
      v-bind="$attrs"
      :class="inputClasses"
      :disabled="props.disabled"
      :name="name"
      :placeholder="props.placeholder"
      :value="modelValue"
      @input="updateValue"
    >
  </div>
</template>


<script setup>
import { computed, defineEmits, defineProps } from 'vue';
import Label from '../label/label.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  className:       { type: String,   default:  null },
  disabled:        { type: Boolean,  default:  false },
  hasError:        { type: Boolean,  default:  false },
  inputClassName:  { type: String,   default:  null },
  label:           { type: String,   default:  null },
  // modelValue:      { type: String,   required: null },
  modelValue:      { type: null, required: false},
  name:            { type: String,   default: null },
  placeholder:     { type: String,   default:  null },
});

const updateValue = (event) => {
  emit('update:modelValue', event.target.value);
};

const classes = computed(() => {
  const classArray = ['input-group'];
  if (props.className)
    classArray.push(props.className);
  return classArray;
});

const inputClasses = computed(() => {
  const classArray = ['input'];
  if (props.hasError)
    classArray.push('input--error');
  if(props.inputClassName)
    classArray.push(props.inputClassName);
  return classArray;
});

const select = () => { console.log("ungabunga"); };

</script>

